'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _sizes = require('HubStyleTokens/sizes');

var _Styles = require('../utils/Styles');

var _decorators = require('../utils/propTypes/decorators');

var _DialogConstants = require('./DialogConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ABOVE_MOBILE_BREAKPOINT = (0, _Styles.toPx)(parseInt(_sizes.GRID_BREAKPOINT_SMALL, 10) + 1);

var Div = _styledComponents2.default.div.withConfig({
  displayName: 'UIDialog__Div'
})(['position:relative;width:', ';@media only screen and (min-width:', '){top:', ';}'], function (_ref) {
  var _dialogWidth = _ref._dialogWidth;
  return (0, _Styles.toPx)(_dialogWidth);
}, ABOVE_MOBILE_BREAKPOINT, function (_ref2) {
  var headerOverflow = _ref2.headerOverflow;
  return (0, _Styles.toPx)(headerOverflow);
});

var UIDialog = function (_React$Component) {
  _inherits(UIDialog, _React$Component);

  function UIDialog() {
    _classCallCheck(this, UIDialog);

    return _possibleConstructorReturn(this, (UIDialog.__proto__ || Object.getPrototypeOf(UIDialog)).apply(this, arguments));
  }

  _createClass(UIDialog, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          centered = _props.centered,
          children = _props.children,
          className = _props.className,
          use = _props.use,
          size = _props.size,
          rest = _objectWithoutProperties(_props, ['centered', 'children', 'className', 'use', 'size']);

      return _react2.default.createElement(
        Div,
        _extends({}, rest, {
          className: (0, _classnames2.default)('private-modal', _DialogConstants.DIALOG_USE_CLASSES[use], _DialogConstants.SIZE_CLASSES[size], 'uiDialog-root', className, { 'private-modal--centered': centered })
        }),
        children
      );
    }
  }]);

  return UIDialog;
}(_react2.default.Component);

UIDialog.propTypes = {
  _dialogWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  centered: _propTypes2.default.bool.isRequired,
  children: _propTypes2.default.node,
  headerOverflow: (0, _decorators.hidden)(_propTypes2.default.number),
  size: _propTypes2.default.oneOf(Object.keys(_DialogConstants.SIZE_CLASSES)),
  use: _propTypes2.default.oneOf(Object.keys(_DialogConstants.DIALOG_USE_CLASSES))
};

UIDialog.defaultProps = {
  centered: false,
  size: 'medium',
  use: 'default'
};

UIDialog.displayName = 'UIDialog';

UIDialog.Selector = Div;

exports.default = UIDialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/dialog/UIDialog.js
// module id = 203
// module chunks = 177